document.addEventListener('DOMContentLoaded', () => {
  const contentWrappers = document.querySelectorAll('.content-wrapper .js-content')
  const activeContentWrapper = document.querySelector(`.content-wrapper .js-content.content-1`)
  const simpleTabsControl = document.querySelectorAll('.js-simple-tabs-control')
  
  contentWrappers.forEach(wrapper => {
    wrapper.style.display = 'none'
  })
  
  if (activeContentWrapper) {
    activeContentWrapper.style.display = 'block'
  }
  
  simpleTabsControl.forEach(control => {
    control.addEventListener('click', () => {
      simpleTabsControl.forEach(tabControl => {
        tabControl.classList.remove('active')
      })
      control.classList.add('active')
      const tabIndex = control.getAttribute('data-tab-index')
      
      const contentWrapper = document.querySelector(`.content-wrapper .js-content.content-${ tabIndex }`)
      
      contentWrappers.forEach(wrapper => {
        wrapper.style.display = 'none'
      })
      if (contentWrapper) {
        contentWrapper.style.display = 'block'
      }
    })
  })
})
// data-tab-index